import axios from 'axios';

import { parameters, getLocale } from '../../../localization/strings';
import { OrderHabits } from '../../../entities/foodId/order-habits';

export const getHabitsResults = async (token: string, hash: string, langUrl?: string): Promise<OrderHabits> => {
  const url = `${parameters().api.baseUrl}/orders/habits-result/${hash}`;

  const res = await axios.get(url, {
    params: {
      language: langUrl || getLocale(),
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};
